import {
    Sheet,
    SheetContent,
    SheetTitle,
    SheetTrigger
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import { useState } from 'react';
import Sidebar from '@/components/navigation/Sidebar';

export default function MobileNav() {
    const [open, setOpen] = useState(false);

    return (
        <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
                <Button variant="ghost" size="sm" className="md:hidden">
                    <Menu className="h-5 w-5" />
                </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-64 p-0">
                <SheetTitle className="sr-only">Navigation menu</SheetTitle>
                <Sidebar
                    collapsed={false}
                    onToggleCollapse={() => {
                        // no-op: mobile nav doesn't collapse
                    }}
                    showCollapseToggle={false}
                    onNavigate={() => setOpen(false)}
                />
            </SheetContent>
        </Sheet>
    );
}
